import React from "react";
import Loadable from "../../react-loadable";

const WeaMenu = Loadable({
  loader: () => import("./Menu"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaMenu;



// WEBPACK FOOTER //
// ./ecology9/wea-menu/index.js